/** InsCoder 2026-06-25 B + Multi featured collection tab switching **/
(function () {
  /** InsCoder 2026-06-25 B + Re-init product card image sliders on tab change **/
  function refreshProductCardSliders(root) {
    if (!root) {
      return;
    }

    root.querySelectorAll('.product-item css-slider.product-item__slider').forEach(function (slider) {
      if (slider.sliderEnabled && typeof slider.resetSlider === 'function') {
        slider.resetSlider(true, true);
      }
    });

    window.dispatchEvent(new Event('resize'));
  }
  /** InsCoder 2026-06-25 E + Re-init product card image sliders on tab change **/

  function updateViewAllLinks(section, tab) {
    const links = section.querySelectorAll('.cmfc-view-all-link');
    if (!links.length) {
      return;
    }

    const defaultHref = links[0].dataset.defaultHref || '';
    const blockLink = tab.dataset.buttonLink;
    const collectionUrl = tab.dataset.collectionUrl;
    const nextHref = blockLink || defaultHref || collectionUrl || '#';

    links.forEach(function (link) {
      link.setAttribute('href', nextHref);
    });
  }

  function activateTab(section, tab, scrollTabIntoView) {
    const blockId = tab.dataset.block;
    const tabs = section.querySelectorAll('.cmfc-tab[data-block]');
    const panels = section.querySelectorAll('.cmfc-panel[data-block]');
    let activePanel = null;

    tabs.forEach(function (item) {
      const isActive = item.dataset.block === blockId;
      item.classList.toggle('active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      const isActive = panel.dataset.block === blockId;
      panel.classList.toggle('active', isActive);
      panel.hidden = !isActive;

      if (isActive) {
        activePanel = panel;
        const slider = panel.querySelector('css-slider.css-slider--bottom-navigation');
        if (slider && typeof slider.resetSlider === 'function') {
          slider.resetSlider();
        }
      }
    });

    if (activePanel) {
      requestAnimationFrame(function () {
        refreshProductCardSliders(activePanel);
      });
    }

    updateViewAllLinks(section, tab);

    if (scrollTabIntoView) {
      tab.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: 'center'
      });
    }
  }

  function initSection(section) {
    const tabs = section.querySelectorAll('.cmfc-tab[data-block]');
    const panels = section.querySelectorAll('.cmfc-panel[data-block]');

    if (!tabs.length || !panels.length) {
      return;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(section, tab, true);
      });
    });

    const activeTab = section.querySelector('.cmfc-tab.active') || tabs[0];
    activateTab(section, activeTab, false);
  }

  function initAll() {
    document.querySelectorAll('.cust-multi-featured-collection[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.cust-multi-featured-collection[data-section-id]');
    if (section) {
      initSection(section);
    }
  });
})();
/** InsCoder 2026-06-25 E + Multi featured collection tab switching **/
